import { render, staticRenderFns } from "./PopupRoot.vue?vue&type=template&id=0f640474"
import script from "./PopupRoot.vue?vue&type=script&lang=ts"
export * from "./PopupRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports